import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const PrintExamsLazy = React.lazy(
	() => import(/* webpackChunkName : 'PrintExams' */ './components')
);

export default (store) => {
	return {
		path: 'exams/print-exams',
		element: <AsyncLoading component={<PrintExamsLazy />} />,
	};
};
